import { Typography } from "@povio/ui";
import Image from "next/image";
import { useRouter } from "next/router";

import DogHeadSmall from "@/assets/icons/navbar/dogheadsmall.png";
import { TreatsButton } from "@/components/shared/layout/sidebar/TreatsButton";
import { RouteConfig } from "@/config/route.config";
import { AuthContext } from "@/data/auth/auth.context";
import { ProfileAnalyticsQueries } from "@/data/profileAnalytics/profileAnalytics.queries";
import useUserProfileAndWorthData from "@/hooks/useUserProfileAndWorthData";

export const UserDataAvatar = () => {
  const { user: authUser } = AuthContext.useAuth();
  const profilePictureUrl = authUser?.profilePictureUrl || "/default-avatar.png";

  return (
    <div
      className="relative h-[54px] w-[54px] min-w-[54px] rounded-s p-2"
      style={{
        backgroundColor: "transparent",
        backgroundImage: profilePictureUrl ? `url(${profilePictureUrl})` : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    />
  );
};

export const UserDataNameAndProfile = () => {
  const { user: authUser } = AuthContext.useAuth();
  const { data: completion } = ProfileAnalyticsQueries.useGetCompletion();
  const completionScore = Math.round(
    ((completion?.profile ?? 0) +
      (completion?.experience ?? 0) +
      (completion?.skills ?? 0) +
      (completion?.projects ?? 0)) /
      4,
  );

  return (
    <div className="flex flex-row items-center justify-start gap-1">
      <Typography
        size="label-3"
        variant="prominent-1"
      >
        {authUser?.user.name}
      </Typography>
      {completionScore ? (
        <div className="rounding-s flex flex-row items-center justify-between gap-1 bg-elevation-fill-default-2 px-1-5 py-0-5">
          <Typography
            size="label-3"
            className="text-text-default-2"
          >
            Profile
          </Typography>
          <Typography
            size="label-3"
            className="text-text-default-2"
          >
            {completionScore}%
          </Typography>
        </div>
      ) : null}
    </div>
  );
};

export const UserDataJobTitle = () => {
  const { userProfile } = useUserProfileAndWorthData();
  const jobTitle = userProfile?.jobPosition;

  if (!jobTitle) return null;

  return (
    <div className="flex flex-row items-center justify-between gap-1 rounded-s border border-elevation-outline-default-1 bg-elevation-fill-default-2 px-1-5 py-0-5">
      <Typography
        size="label-3"
        variant="prominent-1"
      >
        {jobTitle}
      </Typography>
    </div>
  );
};

export const UserDataGradeScore = () => {
  const { data: gradeScore } = ProfileAnalyticsQueries.useGetGradeScore();
  const router = useRouter();

  if (!gradeScore) return null;

  return (
    <div
      onClick={() => router.push(RouteConfig.Analytics)}
      className="flex cursor-pointer flex-row items-center justify-between gap-1 rounded-s border border-interactive-contained-primary-pressed bg-interactive-contained-primary-idle px-1-5 py-0-5"
    >
      <Image
        src={DogHeadSmall}
        alt="Dog head"
        className="h-3-5 w-auto"
      />
      <Typography
        size="label-3"
        variant="prominent-1"
        className="text-interactive-contained-primary-on-idle"
      >
        Grade {gradeScore.score}%
      </Typography>
    </div>
  );
};

export const UserDataInfo = () => {
  return (
    <div className="flex flex-col gap-1">
      <UserDataNameAndProfile />
      <div className="flex flex-row items-center justify-between gap-1">
        <UserDataJobTitle />
        <UserDataGradeScore />
        <TreatsButton />
      </div>
    </div>
  );
};
